import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actions from "../_redux/pasoCuatro/pasoCuatroActions";
import * as actionsEstablecimiento from "../_redux/establecimiento/establecimientoActions";

//CONTEXO
import { PreInscripcionUIConsumer, PreInscripcionUIContext } from '../PreInscripcionUIContext';

//SEARCH SELECT
import Select from 'react-select';

//BOTONES
import Volver from '../components/Volver';
import Continuar from '../components/Continuar';

//Formik
import { Formik, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

//ICONOS USADOS
import SearchIcon from '@material-ui/icons/Search';

//MATERIAL UI CARD  
import { Card, CardContent } from '@material-ui/core';

//RADIO BUTTONS
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';

//ICONOS USADOS
import ErrorIcon from '@material-ui/icons/Error';

//SELECCIONAR DPTO Y LOCALIDAD
import SelectorDepartamento from "../../../../modules/Comun/Departamento/selector";
import SelectorLocalidad from "../../../../modules/Comun/Localidad/selector";
//import SeleccionEstablecimiento from '../establecimiento/SeleccionEstablecimiento';
import SnackBarCustom from '../../../Comun/SnackBars/SnackBarCustom';

const Extras = (props) => {
    const [resultFormik, setResultFormik] = useState(undefined);
    const {
        nivelSeleccionado,
        //establecimientoBandera,
        //establecimientoEstatal,
        dispatchDatosPeronales
    } = useContext(PreInscripcionUIContext);

    const { nivel } = nivelSeleccionado();

    const dispatch = useDispatch();

    const { establecimiento } = useSelector(
        (state) => ({ establecimiento: state.establecimiento }),
        shallowEqual
    );

    const {
        entitiesAbanderado: establecimientosAbanderadoList,
        entitiesEstatales: establecimientosEstatalesList,
        listLoading: listLoadingEstablecimientos,
        //error:errorListadoEstablecimientos
    } = establecimiento;

    const { pasoTres } = useSelector(
        (state) => ({ pasoTres: state.pasoTres }),
        shallowEqual
    );

    const {
        extrasInformacion,
        //listLoading: listLoadingExtras
        //error:errorListadoEstablecimientos
    } = pasoTres;

    const { pasoCuatro } = useSelector(
        (state) => ({ pasoCuatro: state.pasoCuatro }),
        shallowEqual
    );

    const {
        actionsLoading: actionsLoadingPaso4,
        error: errorPaso4
    } = pasoCuatro;

    const { nextStep } = props;

    

    //DATOS ESTATAL
    const [estatal, setEstatal] = useState(false);
    //const [defaultEstatal, setDefaultEstatal] = useState();
    const [cargoDefaultEstatal, setCargoDefaultEstatal] = useState(0);
    const [seleccionadoEstablecimiento, setSeleccionadoEstablecimiento] = useState();
    const [estatalDepartamento, setEstatalDepartamento] = useState(undefined);
    const [estatalLocalidad, setEstatalLocalidad] = useState(undefined);
    const [estatalLocalidades, setEstatalLocalidades] = useState([])//aca van las localidades filtradas por dpto

    //DATOS BANDERA
    const [bandera, setBandera] = useState(false);
    //const [defaultBandera, setDefaultBandera] = useState();
    const [cargoDefaultBandera, setCargoDefaultBandera] = useState(0);
    const [seleccionadoBandera, setSeleccionadoBandera] = useState();
    const [banderaDepartamento, setBanderaDepartamento] = useState(undefined);
    const [banderaLocalidad, setBanderaLocalidad] = useState(undefined);
    const [banderaLocalidades, setBanderaLocalidades] = useState([])//aca van las localidades filtradas por dpto

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const extraSchema = Yup.object().shape({
        fueEstatal: Yup.boolean()
            .required("Debe seleccionar una opción"),
        fueAbanderaro: Yup.boolean()
            .required("Debe seleccionar una opción"),
    });
    const banderaSchema = Yup.object().shape({
        establecimientoBandera: Yup.string()
            .required("Debe ingresar el establecimiento"),
    });
    const estatalSchema = Yup.object().shape({
        establecimientoEstatal: Yup.string()
            .required("Debe ingresar el establecimiento"),
    });

    //const fullSchema = extraSchema.clone().concat(estatalSchema).concat(banderaSchema);

    useEffect(() => {
        if (banderaDepartamento && banderaLocalidad) {
            dispatch(actionsEstablecimiento.fetchEstablecimientosAbanderado({
                departamentoId: banderaDepartamento.id,
                localidadId: banderaLocalidad.id,
                nivelEnsenanza: 'Primario'
            }));
        }
    }, [banderaDepartamento, banderaLocalidad, dispatch]);

    useEffect(() => {
        if (estatalDepartamento && estatalLocalidad) {
            dispatch(actionsEstablecimiento.fetchEstablecimientosEstatales({
                departamentoId: estatalDepartamento.departamentoId,
                localidadId: estatalLocalidad.localidadId,
                palabraABuscar: nivel
                //esPrivada: false
            }));
        }
    }, [estatalDepartamento, estatalLocalidad, dispatch]);

    function iniciarEstablecimientoEstatal(item) {
        setSeleccionadoEstablecimiento({
            id: item.establecimientoAnteriorId,
            nombre: item.establecimientoAnteriorNombre,
        });
        setCargoDefaultEstatal(cargoDefaultEstatal + 0);
        setEstatal(true);
    };

    function iniciarEstablecimientoBandera(item) {
        setSeleccionadoBandera({
            id: item.establecimientoAbanderadoId,
            nombre: item.establecimientoAbanderadoNombre
        });
        setCargoDefaultBandera(cargoDefaultBandera + 1);
        setBandera(true);
    };

    useEffect(() => {
        if (!actionsLoadingPaso4 && !errorPaso4 && resultFormik) {
            scrollTop();
            setTimeout(() => {
                dispatchDatosPeronales({ type: 'guardarExtras', payload: resultFormik });
                setResultFormik(undefined);
                nextStep();
            }, 400);
        };
    }, [actionsLoadingPaso4, errorPaso4, resultFormik]);

    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    {extrasInformacion && extrasInformacion.establecimientoAnteriorId && cargoDefaultEstatal === 0 && iniciarEstablecimientoEstatal(extrasInformacion)}
                    {extrasInformacion && extrasInformacion.establecimientoAbanderadoId && cargoDefaultBandera === 0 && iniciarEstablecimientoBandera(extrasInformacion)}
                    <Card style={{ backgroundColor: "#f7f7f7" }}>
                        <CardContent className="d-flex flex-row align-items-center ml-2">
                            <div className="border-left border-2 border-warning p-3 br-4">
                                <ErrorIcon className="text-warning" fontSize="large" />
                            </div>
                            <div>
                                <b>IMPORTANTE</b>
                                <p>Estas preguntas te permitirán agregar información valiosa para la asignación de vacante, por favor léelas con atención.</p>
                            </div>
                        </CardContent>
                    </Card>
                    <br />
                    <h3 className="text-center" >EXTRAS</h3>
                    <div className="d-flex flex-row justify-content-between">
                        <p className="font-weight-bold">Datos Relevantes</p>
                        <p className="text-muted">(*)Campos Obligatorios</p>
                    </div>

                    <Formik
                        initialValues={value.valoresExtras()}
                        validationSchema={
                            bandera && estatal ? estatalSchema.concat(extraSchema) :
                                bandera && !estatal ? banderaSchema.concat(extraSchema) :
                                    estatal && !bandera ? estatalSchema.concat(extraSchema) :
                                        extraSchema

                            /* ORIGINAL
                            bandera && estatal ? fullSchema :
                                bandera && !estatal ? banderaSchema.concat(extraSchema) :
                                    estatal && !bandera ? estatalSchema.concat(extraSchema) :
                                        extraSchema
                            */
                        }
                        onSubmit={(values) => {
                            let aux = null
                            if (estatal && bandera) {
                                aux = seleccionadoEstablecimiento.establecimientoId;
                            } else if (!estatal && bandera) {
                                aux = seleccionadoBandera.establecimientoId;
                            };
                            dispatch(actions.fetchPasoCuatroAlCinco({
                                inscripcionId: value.valoresExtrasAspirante().inscripcionId,
                                establecimientoAnteriorId: estatal ? seleccionadoEstablecimiento.establecimientoId : null,
                                establecimientoAbanderadoId: aux,
                            }));

                            if (!estatal) {
                                values.establecimientoEstatal = "";
                                setSeleccionadoEstablecimiento();
                            };
                            if (!bandera) {
                                values.establecimientoBandera = "";
                                setSeleccionadoBandera();
                            };

                            setResultFormik(values);
                        }}
                    >
                        {formik =>
                            <Form>
                                <div className="form-group">
                                    <label htmlFor="fueEstatal">
                                        ¿El aspirante concurrió el año anterior a algún establecimiento de gestión estatal perteneciente al Ministerior de Educación de Corrientes?
                                    </label>
                                    <RadioGroup
                                        aria-label="position"
                                        name="fueEstatal"
                                        value={estatal}
                                        onChange={() => {
                                            formik.setFieldValue("fueEstatal", !formik.values.fueEstatal);
                                            formik.setFieldValue("establecimientoEstatal", "");
                                            setEstatal(!estatal);
                                            if (!estatal) {
                                                setSeleccionadoEstablecimiento();
                                                setEstatalDepartamento(undefined);
                                                setEstatalLocalidad(undefined);
                                                setEstatalLocalidades([]);
                                            };
                                        }}
                                        row
                                    >
                                        <FormControlLabel
                                            value={true}
                                            control={<Radio color="primary" />}
                                            label="Si"
                                        />
                                        <FormControlLabel
                                            value={false}
                                            control={<Radio color="primary" />}
                                            label="No"
                                        />
                                    </RadioGroup>
                                </div>
                                {formik.values.fueEstatal &&
                                    <>
                                        <div className="row justify-content-between align-items-top" >
                                            <div className="form-group col-12 col-sm-6">
                                                <label>Seleccionar Departamento</label>
                                                <SelectorDepartamento setLocalidadesChild={setEstatalLocalidades} setLocalidadChild={setEstatalLocalidad} setDepartamentoChild={setEstatalDepartamento} soloConOfertas={false} />
                                            </div>
                                            <div className="form-group col-12 col-sm-6">
                                                <label>Seleccionar Localidad</label>
                                                <SelectorLocalidad setLocalidadChild={setEstatalLocalidad} localidadesChild={estatalLocalidades} localidadChild={estatalLocalidad} soloConOfertas={false} />
                                            </div>
                                        </div>
                                        <div className="form-group ">
                                            <div className="input-group">
                                                <div className="input-group-prepend" >
                                                    <label className="input-group-text bg-white" ><SearchIcon /></label>
                                                </div>
                                                <Select
                                                    className="form-control m-0 p-0 b-0 basic-multi-select"
                                                    placeholder="Establecimientos"
                                                    value={seleccionadoEstablecimiento ? seleccionadoEstablecimiento : ""}
                                                    options={establecimientosEstatalesList}
                                                    getOptionValue={({ establecimientoId }) => establecimientoId}
                                                    getOptionLabel={({ establecimiento }) => `${establecimiento}`}
                                                    isSearchable
                                                    noOptionsMessage={() => "No hay mas establecimientos"}
                                                    isLoading={listLoadingEstablecimientos}
                                                    isDisabled={!(estatalDepartamento && estatalLocalidad)}
                                                    onChange={(item) => {
                                                        //console.log(item);
                                                        if (item) {
                                                            setSeleccionadoEstablecimiento(item);
                                                            formik.setFieldValue("establecimientoEstatal", item.establecimiento);
                                                        };
                                                        if (!item) {
                                                            setSeleccionadoEstablecimiento();
                                                            formik.setFieldValue("establecimientoEstatal", "");
                                                        };
                                                    }}
                                                />
                                            </div>
                                            <div className="text-danger"><ErrorMessage name="establecimientoEstatal" /></div>
                                        </div>
                                    </>
                                }
                                {nivel === 'Secundario' && (
                                    <div className="form-group">
                                        <label htmlFor="fueAbanderaro">¿El aspirante fue abanderado o escolta con la bandera de ceremonia?</label>
                                        <RadioGroup
                                            aria-label="position"
                                            name="fueAbanderaro"
                                            value={bandera}
                                            onChange={() => {
                                                formik.setFieldValue("fueAbanderaro", !formik.values.fueAbanderaro);
                                                formik.setFieldValue("establecimientoBandera", "");
                                                setBandera(!bandera);
                                                if (!bandera) {
                                                    setSeleccionadoBandera();
                                                    setBanderaDepartamento(undefined);
                                                    setBanderaLocalidad(undefined);
                                                    setBanderaLocalidades([]);
                                                };
                                            }}
                                            row
                                        >
                                            <FormControlLabel
                                                value={true}
                                                control={<Radio color="primary" />}
                                                label="Si"
                                            />
                                            <FormControlLabel
                                                value={false}
                                                control={<Radio color="primary" />}
                                                label="No"
                                            />
                                        </RadioGroup>
                                    </div>
                                )}
                                {(nivel === 'Secundario' && !formik.values.fueEstatal) /* AGREGO PARA QUE SOLO PIDA ESTABLECIMIENTO SI NO LO SELECCIONO EN LA PREGUNTA ANTERIOR */
                                    && formik.values.fueAbanderaro &&
                                    <>
                                        <div className="row justify-content-between align-items-top" >
                                            <div className="form-group col-12 col-sm-6">
                                                <label>Seleccionar Departamento</label>
                                                <SelectorDepartamento setLocalidadesChild={setBanderaLocalidades} setLocalidadChild={setBanderaLocalidad} setDepartamentoChild={setBanderaDepartamento} />
                                            </div>
                                            <div className="form-group col-12 col-sm-6">
                                                <label>Seleccionar Localidad</label>
                                                <SelectorLocalidad setLocalidadChild={setBanderaLocalidad} localidadesChild={banderaLocalidades} localidadChild={banderaLocalidad} />
                                            </div>
                                        </div>
                                        <div className="form-group ">
                                            <div className="input-group">
                                                <div className="input-group-prepend" >
                                                    <label className="input-group-text bg-white" ><SearchIcon /></label>
                                                </div>
                                                <Select
                                                    className="form-control m-0 p-0 b-0 basic-multi-select"
                                                    placeholder="Establecimientos"
                                                    value={seleccionadoBandera}
                                                    options={establecimientosAbanderadoList}
                                                    getOptionValue={({ establecimientoId }) => establecimientoId}
                                                    getOptionLabel={({ establecimiento }) => `${establecimiento}`}
                                                    isSearchable
                                                    noOptionsMessage={() => "No hay mas establecimientos"}
                                                    isLoading={listLoadingEstablecimientos}
                                                    isDisabled={!(banderaDepartamento && banderaLocalidad)}
                                                    onChange={(item) => {
                                                        //console.log(item);
                                                        if (item) {
                                                            setSeleccionadoBandera(item);
                                                            formik.setFieldValue("establecimientoBandera", item.establecimiento);
                                                        };
                                                        if (!item) {
                                                            setSeleccionadoBandera();
                                                            formik.setFieldValue("establecimientoBandera", "");
                                                        };
                                                    }}
                                                />
                                            </div>
                                            <div className="text-danger"><ErrorMessage name="establecimientoBandera" /></div>
                                        </div>
                                    </>
                                }
                                <div className="row justify-content-center mb-3">
                                    <Volver {...props} />
                                    <Continuar tipo="continuar" spinner={actionsLoadingPaso4} />
                                </div>
                            </Form>
                        }
                    </Formik>
                    {errorPaso4 && <SnackBarCustom tipo="error" mensaje={errorPaso4} />}
                </>
            }
        </PreInscripcionUIConsumer>
    )
}

export default Extras;